const uuidV4Regex = /^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;
export function isUuidV4(s) {
    return uuidV4Regex.test(s);
}
//# sourceMappingURL=uuid.js.map